<div class="main">
  <app-upload-brand-result></app-upload-brand-result>
  <!-- TODO Пока не знаю что с этим сделать  -->
  <!-- <app-upload-article-result></app-upload-article-result> -->
</div>
